import frLocal from 'vant/lib/locale/lang/en-US'
import frJame from './languageJame/fr'
import frGaea from './languageGaea/fr'
import frAllen from './languageAllen/fr'
const fr = {
  300000: '新年送礼',
  300001: '2022新年送礼',
  300002: 'SuperEx和你一起过新年',
  300003: '尊敬的SuperEx用户：<br>为庆祝SuperEx在新年之际盛大上线,<br>平台将随机空投送出价值1,000,000 USDT新年大礼包。 <br>具体活动如下：',
  300004: '活动时间<br>加拿大时间：2022年01月01日00：00-02月15日23：59',
  300005: '活动一：分享海报获空投',
  300006: '分享活动海报至＞1000人的telegram加密货币群组，并附言“百万豪礼大派送，SuperEx和你一起过新年！或分享活动海报至个人Tiwwer，置顶并附言“百万豪礼大派送，SuperEx和你一起过新年！ ”上传截图给客服，将有机会获得5 ET（价值5 USDT）。',
  300007: '活动二：邀新获VIP',
  300008: '获得期间，用户通过邀请好友新注册并成功入金≥100 USDT即为有效邀请人数。成功邀请人数越多，所获VIP等级越高。有效期（30天）',
  300009: '活动三：新用户充值送',
  300010: '活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）',
  300011: '注意事项：',
  300012: '1.每位参与用户只能获得一次奖励 <br>2.所有参与用户默认遵守SuperEx服务条款，如发现违规将立即停止其活动资格 <br>3.SuperEx有权在不提早通知用户的情况下修改本次活动的条款 <br>4.SuperEx将取消不合规用户活动参与资格并停用相关SuperEx账户使用 <br>5.SuperEx保留本次活动最终解释权',
  300013: '立即分享',
  300014: 'SuperEx团队',
  300015: '2022年01月01日',
  300016: '更多信息关注SuperEx官网：SuperEx.com',
  300017: '净充值金额（{coin}）',
  300018: '奖励金（{coin}）',
  300019: '180天',
  300020: '净充值=总入金金额-总出金金额',
  300021: 'ET持仓数量',
  300022: 'Maker/Taker',
  300023: '有效邀请人数',
  300024: '赠送有效期',
  300025: '活动获取条件',
  300026: '注：所有赠送的VIP等级均无需ET持仓要求。 ',

  300027: 'Copie réussie',
  300028: 'Copie échouée',

  300029: ' Télécharger SuperEx APP',
  300030: `Trade à tout moment et n'importe où`,
  300031: 'Créer un compte SuperEx',
  300032: '若您已有SuperEx账户，请先登录',
  300033: 'E-mail',
  300034: 'Mobile',
  300035: 'Numéro de téléphone',
  300036: 'Mot de passe',
  300037: 'ID de parrain (facultatif)',
  300038: `J'ai lu et j'accepte les`,
  300039: 'Conditions de service SuperEx',
  300040: `J'ai plus de 18 ans et j'accepte les conditions de service SuperEx`,
  300041: `S'inscrire`,
  300042: 'Vérification de sécurité',
  300043: 'Sélectionner le code de zone',
  300044: 'Recherche',
  300045: 'Veuillez saisir votre numéro de téléphone',
  300046: 'Entrer un numéro de téléphone correct',
  300047: 'Veuillez saisir votre adresse e-mail',
  300048: 'Veuillez saisir une adresse email valide',
  300049: 'Veuillez saisir votre mot de passe',
  300050: 'Au moins 8 caractères, y compris des majuscules et des chiffres',
  300051: 'Code de vérification par e-mail',
  300052: 'Code de vérification par SMS',
  300053: `Code D'Authentificateur Google/Microsoft`,
  300054: 'Google',
  300055: 'Pour la sécurité de votre compte, veuillez effectuer les vérifications suivantes',
  300056: 'Soumettre',
  300057: 'Un code à 6 chiffres sera envoyé sur votre téléphone {phone}',
  300058: 'Le code sera envoyé à @.{email}',
  300059: 'Veuillez entrer le code à 6 chiffres de SuperEx/Google/Microsoft',
  300060: 'Veuillez entrer un code à 6 chiffres',
  300061: 'Envoyer le Code',
  300062: 'Renvoyer dans {timeout}s',
  300063: 'Langue',
  300064: 'En cours de vérification',
  300065: 'Saisissez des lettres anglaises ou des signes de ponctuation courants',


  300066: 'Centre de tâches',
  300067: 'Classement de la remise',
  300068: `Réclamez jusqu'à <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em> !`,
  300069: 'Inviter',
  300070: 'Classement',
  300071: 'Règles de déverrouillage',
  300072: 'Recevez plus de ET',
  300073: `Classement de la remise. Jusqu'à 1 BTC vous attend !`,
  300074: 'Effectuez les transactions pour débloquer des ET',
  300075: 'Terminez toutes les tâches ci-dessus pour être autorisé et SuperEx distribuera de manière aléatoire des quantités importantes de jetons ET aux utilisateurs autorisés de temps en temps.',
  300076: 'Classement quotidien',
  300077: 'Classement total',
  300078: `Conditions d'utilisation`,
  300079: 'Mes récompenses',

  300080: 'Montant bloqué',
  300081: 'Montant débloqué',
  300082: `Montant débloqué = frais de transaction * difficulté de déverrouillage / prix de l'ET`,
  300083: 'Aller vers les échanges',
  300084: 'Classement',
  300085: 'Compte',
  300086: 'Commission',
  300087: `Remarque : le classement du jour est calculé jusqu'à 00h00 et les récompenses sont distribuées le lendemain. Les données peuvent présenter des erreurs et sont fournies à titre indicatif uniquement.`,
  300088: `Remarque : les récompenses seront distribuées dans les 3 jours ouvrables suivant la fin de l'activité. Les données peuvent présenter des erreurs et sont fournies à titre indicatif uniquement.`,
  300089: 'Afficher plus',

  300090: 'Fermer',
  300091: 'Vous êtes déjà un utilisateur de la liste blanche!',
  300092: 'Veuillez entrer votre compte {type}',
  300093: 'Étape finale',
  300094: 'Suivez-nous sur Twitter',
  300095: 'Rejoignez notre groupe Telegram officiel',
  300096: 'Commencer le dépôt',
  300097: 'Commencer la transaction au Spot',
  300098: 'Entrer immédiatement dans la transaction à terme',
  300099: 'Recommandez immédiatement des amis à  joindre',

  300100: 'Invitez un ami à faire des échanges',
  300101: 'Recommandez à un ami de faire plus de transactions',
  300102: 'Déposer',
  300103: 'Suivre',
  300104: 'Réclamer',
  300105: 'Collecté (fois)',
  300106: 'Pas encore ouvert',
  300107: 'Rejoindre',
  300108: 'Aucun enregistrement trouvé',
  300109: 'Terminé',
  300110: 'Invitez des amis et recevez plus de SCS',
  300111: 'Annuler',
  300112: 'Soumettre',
  300113: 'Ne soumettez pas à nouveau',
  300114: `Il n'y a actuellement aucune tâche`,
  300115: `Restez à l'écoute pour plus de tâches`,
  300116: `Restez à l'écoute pour plus d'événements !`,
  300117: 'Veuillez saisir votre compte',
  300118: 'Veuillez saisir votre compte',
  300119: 'Refusé',
  300120: 'Inscription instantanée à SuperEx',
  300121: `S'inscrire`,
  300122: 'Expiré',
  300123: 'Livre blanc',

  300124: 'Boite de Surprises',
  300125: 'Ouvrez une boîte de surprises avec vos amis avec un taux de gain de <em class="normal bold" style="color: #FFC72B">100%</em>',
  300126: 'Règles',

  300127: 'Ouvrir une boîte de surprise',
  300128: 'Nombre de tirages',
  300129: 'Restants (les miens)',
  300130: 'Ouverts (total en USDT)',
  300131: 'Récompenses',
  300132: 'Comment participer ?',
  300133: `Partagez votre lien d'invitation`,
  300134: 'Accomplissez les tâches',
  300135: `Invitez vos amis à s'inscrire et à effectuer des tâches de trading`,
  300136: 'Recevez une boîte surprise',

  300137: 'Accomplissez les tâches et obtenez la boîte de Surprises',
  300138: 'Cette activité est terminée, veuillez attendre la prochaine activité !',
  300139: `Cette activité n'a pas encore commencé, veuillez attendre avec impatience !`,
  300140: `Règles de l'événement`,
  300141: 'OK',
  300142: 'Temps',
  300143: 'Recherche',
  300144: 'Authentification par e-mail',
  300145: 'Inviter des amis',
  300146: `Illuminez les lanternes d'Halloween et amusez-vous avec <em class="normal" style="color: #FFC72B">Halloween</em>.`,
  300147: 'Connectez-vous pendant <em class="normal" style="color: #FFC72B">{num}</em> jours consécutifs et ayez une chance de gagner le prix <em class="normal" style="color: #FFC72B">{amount} ET</em>.',
  300148: 'Liste des gagnants',
  300149: 'Connexion quotidienne.',

  300150: 'Vous êtes connecté depuis {num} jours.',
  300151: 'Tirage au sort des prix.',
  300152: 'Connecté.',
  300153: 'Connectez-vous.',
  300154: '',
  300155: '',
  300156: 'Connectez-vous.',
  300157: 'Vous avez reçu un coupon de réduction sur les frais de contrat.',
  300158: 'Mise à niveau VIP réussie!',
  300159: 'Obtenez une chance de gagner à la loterie!',

  300160: 'Coupon de frais de contrat.',
  300161: 'Mise à niveau VIP',
  300162: '',
  300163: 'Vous avez <em class="normal" style="color: #FFC72B">{num}</em> fois la possibilité de vous reconnecter.',
  300164: 'Obtenez une chance de vous connecter.',
  300165: 'Peut se reconnecter.',
  300166: 'Conseils',
  300167: 'Reconnexion réussie.',
  300168: `Vous n'avez pas encore le nombre de connexions, vous pouvez obtenir une reconnexion pour un dépôt net de ≥{num} {symbol} le même jour`,
  300169: 'Connexion',

  300170: 'Vous avez atteint la limite de reconnexion.',
  300171: 'Liste des gagnants des utilisateurs qui se sont connectés pendant 7 jours consécutifs.',
  300172: 'Connectez-vous continuellement pour obtenir les récompenses suivantes.',
  300173: 'Réclamé.',
  300174: '{num} jours',
  300175: 'Coupon.',
  300176: 'Mon Niveau VIP',
  300177: 'Participez à la loterie.',
  300178: 'Félicitations!',
  300179: 'Connecté avec Succès',
  300180: '',
  300181: 'Académie.',
  300182: 'Actualités',
  300183: 'Données',
  300184: 'Académie',
  300185: `Obtenez un aperçu approfondi des principaux événements de l'industrie mondiale de la cryptographie.`,
  300186: `Obtenez un aperçu rapide des derniers événements de l'industrie de la cryptographie dans le monde entier.`,
  300187: 'Apprenez tout sur la blockchain, Web3 et les cryptomonnaies.',
  300188: 'Lire la suite',
  300189: 'Vidéos',
  300190: 'Chargement en cours...',
  300191: 'Tout chargé',
  300192: 'Tout',
  300193: `Le tournoi n'a pas encore commencé.`,
  300194: 'Choisissez le vainqueur des matchs de la Coupe du Monde et gagnez des <em class="normal" style="color: #DBFF00">récompenses</em>.',
  300195: `Horaire de l'événement.`,
  300196: ' Historique des votes',
  300197: 'Phase de groupes.',
  300198: 'Groupe {num}.',
  300199: 'Fonds de prix : {num}.',
  300200: 'Voter.',
  300201: 'Phase éliminatoire.',
  300202: 'Compétition.',
  300203: 'Date limite des votes.',
  300204: 'Voter.',
  300205: 'Veuillez entrer le nombre de votes.',
  300206: 'Montant minimum de pari: {num} ET',
  300207: 'Période de prédiction.',
  300208: 'Parier sur les équipes.',
  300209: 'Votes',
  300210: 'Montant du prix',
  300211: 'Équipes qualifiées.',
  300212: 'J',
  300213: 'H',
  300214: 'M',
  300215: 'S',
  300216: 'Matchs',
  300217: `L'événement n'a pas encore commencé.`,
  300218: '[1/4] Finale',
  300219: 'Confirmer',
  300220: 'Nombre de votes.',
  300221: 'Solde insuffisant',
  300222: 'Déposer',
  300223: 'Prédiction réussie.',
  300224: '[1/8] Finale.',
  300225: 'Demi-finale.',
  300226: 'Finalistes de la troisième et quatrième place.',
  300227: 'Finale',
  300228: 'Victoire',
  300229: 'Défaite',
  300230: 'Fonds de prix total：{num} ET',
  300231: 'Voir plus de matchs',
  300232: 'Autres Competitions',
  300233: 'Devise',
  300234: 'Prix du Marché',
  300235: '24h chg%',
  300236: 'Guide pour débutants',
  300237: 'Commencez à apprendre le trading de crypto-monnaies dès maintenant',
  300238: 'Présence mondiale',
  300239: `Sans frontières, décentralisation et autonomie de la communauté, la décentralisation de l'équipe est la forme ultime du développement de SuperEx`,

  300240: 'Aucun risque de sécurité',
  300241: `Le SuperWallet décentralisé est intégré, et la clé privée est cryptée et stockée sur le dispositif de l'utilisateur. Non affecté par la sécurité du code, la politique et d'autres facteurs`,
  300242: 'Aucune inscription et aucun',
  300243: 'Les transactions autorisées par portefeuille, sans inscription, sans KYC, les règlements de transactions sont effectués sur la chaîne, ne peuvent pas être altérés, sûrs et transparents',
  300244: 'Système ouvert',
  300245: `Permettre aux utilisateurs d'interagir avec Dapp ou des contrats intelligents, en ouvrant SuperWallet, les utilisateurs peuvent être autorisés à participer à Meta, DeFi et NFT`,
  300246: 'Fond spatial',
  300247: `Le fond spatial est utilisé pour l'exploration spatiale humaine ou pour financer des organisations ou des individus qui contribuent grandement à l'exploration spatiale humaine`,
  300248: `Une plateforme d'échange sécurisée et facile à utiliser`,
  300249: `Téléchargez l'application mobile SuperEX pour surveiller les marchés et effectuer des transactions au moment parfait, où que vous soyez.`,

  300250: `Plus d'options de téléchargement`,
  300251: `Chaque transaction que vous effectuez est un carburant pour que les humains s'envolent dans l'espace`,
  300252: 'Inscrivez-vous dès maintenant',
  300253: 'Scan pour télécharger sur iOS et Android',
  300254: 'Authentificateur',
  300255: 'Google Authenticator génère un code de vérification à deux étapes pour vous. Sécurisez votre compte SuperEx avec la vérification à deux étapes.',
  300256: 'SuperEx Authenticator',
  300257: 'Google Authenticator',
  300258: 'Authentification Microsoft',
  300259: 'Téléchargez le client (iPhone)',

  300260: 'Téléchargez le client (Android)',
  300261: `La plateforme d'échange d'actifs numériques la plus fiable au monde`,
  300262: 'A propos de nous',
  300263: 'Conditions',
  300264: 'Confidentialité',
  300265: 'Annonces',
  300266: 'Académie',
  300267: 'Centre pour débutants',
  300268: 'Trading spot',
  300269: 'Futures',

  300270: 'FAQ',
  300271: 'Service',
  300272: 'Frais',
  300273: 'Règles',
  300274: 'Demande de cotation',
  300275: 'Parrainage',
  300276: 'Contactez-nous',
  300277: `Centre d'aide`,
  300278: 'Soumettre une demande',
  300279: 'Contacts professionnels',

  300280: 'Coopération institutionnelle',
  300281: 'Plus',
  300282: 'Heureux de vous revoir !',
  300283: 'Mot de passe oublié?',
  300284: `Vous n'avez pas encore de compte ?`,
  300285: `Allez sur l'application ou l'ordinateur pour récupérer le mot de passe`,
  300286: 'Je l’ai compris',

  300287: 'Confirmer',
  300288: 'En Attente',
  300289: 'À réclamer',

  300290: 'Déjà participé',
  300291: 'Déjà réclamé',
  300292: `Règles d'achat`,
  300293: 'Acheter<span>Produits</span>',
  300294: 'Choisir et acheter',
  300295: 'En attente de résultats',
  300296: `Réclamer l'article`,
  300297: 'Dépôt',
  300298: 'Historique des achats',
  300299: 'Liste des articles',
  300300: 'Frais de participation unique',
  300301: `{num} exemplaires ont été vendus. L'article sera vendu après avoir atteint {price} {currency}.`,
  300302: 'Rejoignez maintenant',
  300303: 'Rejoignez à nouveau',
  300304: ' Choisissez le nombre de copies à acheter',
  300305: "1 exemplaire coûte <span class='span'>{minPrice} {currency}</span>, et un seul article peut être acheté, au maximum",
  300306: 'Copies',
  300307: 'Vous avez {num}{currency}, plus vous achetez de copies, plus vous avez de chances de réussir',
  300308: 'Acheter',
  300309: 'La prochaine fois',
  // 300309: '余额充值',
  300310: 'Félicitations',
  300311: 'Réclamer',
  300312: 'Réessayez !',
  300313: `Veuillez effectuer une recharge ou un dépôt P2P dans l'application`,
  // 300314: '我知道了',
  300315: `Contactez le service client sur l'application pour réclamer l'article.`,
  // 300316: '我知道了',
  300317: 'Connexion/inscription',
  300318: 'Coût{num} {currency}',
  300319: `Description de l'article`,
  300320: 'Ma participation',
  300321: 'Temps',
  300322: 'Articles participants',
  300323: `Nombre d'exemplaires achetés`,
  300324: 'Montant du remboursement',
  300325: 'Opération',
  300326: 'Réclamer',
  300327: 'Vous avez déjà un compte ?',
  300328: 'Connexion',
  300329: `Code D'Authentication`,
  300330: `Seules les sept derniers jours d'enregistrements sont affichés`,
  300331: 'Authentificateur',
  300332: ' Télécharger',
  300333: '1 USDT for 1 Bitcoin！',
  300334: "Prix d'achat",
  300335: "Résultats précédents",
  // 300336:"期次",
  300337: "Voir les règles",
  300338: "Problème : [Phase {num}]",
  300339: "Processus d'achat",
  300340: "Utilisateurs ayant acheté avec succès",
  300341: "Heure de l'annonce",
  300342: "Partager",
  300343: "Problème [{num}]",
  300345: "Télécharger",
  300346: "Partagez votre joie",
  300347: "Scanner le code pour rejoindre",
  300348: "Réclamer l'article",
  300349: "Remarque : Les articles de crypto-monnaie seront envoyés sur votre compte dans un délai de 48 heures.",
  300350: "Contactez le service client pour réclamer d'autres articles",
  300351: "Aller voir",
  300352: "S'enregistrer Maitenant",
  300353: "Enregistré",
  300354: 'Enregistrement Fermé',
  300355: 'Inscription réussie',
  300356: `Ouvrir l'application`,
  300357: 'Félicitations à {user} pour avoir remporté un {shop} !',
  300358: 'Centre des Événements',
  300359: 'En cours',
  300360: 'À venir',
  300361: 'Terminé',
  300362: 'Rejoignez maintenant',
  300363: 'Terminé',
  300364: 'Liste des gagnants',
  300365: 'Les gagnants seront annoncés prochainement',

  310000: 'Aperçu général des récompenses',
  310001: 'SCS Largage aérien',

  300366: 'Devise',
  300367: 'Vendre',
  200368: 'Payer',
  300369: 'Recevoir',
  300370: 'Obtenir',
  300371: 'Limite de paiement unique:',
  300372: 'Moyen de paiement',
  300373: 'Méthode de paiement',
  300374: 'Fournisseur de paiement',
  300375: 'Détails de la commande',
  300376: 'Montant (frais de transaction inclus)',
  300377: `Temps d'arrivée`,
  300378: 'Clause de non-responsabilité',
  300379: `J'ai lu et j'accepte la clause de non-responsabilité`,
  300380: `Vous quitterez SuperEx et serez redirigé vers [1], une institution financière agréée qui propose des capacités de traitement des paiements par carte en tant que tiers. Tout événement à risque survenant lors de l'utilisation sera supporté par [1]. Veuillez lire et accepter l'accord de service de [1] avant d'utiliser ses services.
    Si vous avez des questions sur les dépôts par carte de crédit, veuillez contacter le Service Client de [1] pour plus de détails.`,
  300381: 'Comment acheter des crypto-monnaies sur SuperEx ?',
  300382: 'Comment Vendre des Cryptomonnaies sur SuperEx ?',
  300383: 'Passez votre commande de crypto',
  300384: 'Choisissez la devise fiduciaire avec laquelle vous souhaitez payer et la crypto-monnaie que vous souhaitez acheter. Indiquez le montant que vous souhaitez dépenser.',
  300385: 'Vérifiez votre identité',
  300386: 'Effectuez la vérification KYC sur SuperEx et le fournisseur de paiement pour finaliser le paiement.',
  300387: 'Vérifiez les détails de votre commande',
  300388: `Consultez votre historique de dépôts pour voir l'état de votre commande.`,
  300389: 'FAQ',
  300390: '1. Quels modes de paiement puis-je utiliser pour acheter des cryptomonnaies ?',
  300391: `SuperEx prend actuellement en charge les modes de paiement VISA, Mastercard, Apple Pay, Google Pay et d'autres. Les prestataires de services tiers pris en charge incluent Mercuryo et alchemypay.`,
  300392: '2. Quelles cryptomonnaies puis-je acheter ?',
  300393: 'SuperEx prend en charge les cryptomonnaies populaires telles que BTC, ETH, USDT, LTC, USDC, XRP, BCH, CRV et TRX.',
  300394: '3. SuperEx surveille-t-il la qualité et les prix des prestataires de services tiers pris en charge ?',
  300395: `SuperEx a soigneusement sélectionné un certain nombre de prestataires de services ayant une réputation fiable dans l'industrie, une popularité et une sécurité pour fournir aux utilisateurs des services simplifiés.`,
  300396: '4. Quels frais dois-je payer pour acheter des cryptomonnaies ?',
  300397: 'Vous payez des frais au prestataire de services tiers et des frais de transfert sur la chaîne. SuperEx ne facture aucun frais.',
  300398: '5. Combien de temps faut-il pour recevoir les cryptomonnaies après le paiement ?',
  300399: 'Après que votre paiement est effectué sur la plateforme du prestataire de services tiers, vos cryptomonnaies seront déposées sur votre compte spot sur SuperEx en environ 2 à 10 minutes.',
  300400: `6. Que faire si je rencontre des problèmes lors du processus d'achat ?`,
  300401: `Contactez le support client si vous rencontrez des problèmes lors du processus de transaction. Si vous n'avez pas reçu les cryptomonnaies après l'achèvement du paiement, contactez le prestataire de services tiers pour vérifier les détails de la commande (c'est généralement la méthode la plus efficace). En raison de l'adresse IP de votre région actuelle ou de certaines raisons politiques, vous devrez peut-être sélectionner une vérification humaine.`,
  300402: "Disponible",
  300403: 'Solde insuffisant',
  300404: 'Entrer la devise',
  300405: 'Saisir la devise fiduciaire.',
  300406: `Vous n'avez pas terminé la vérification d'identité`,
  300407: "Pour la sécurité de votre compte avec d'autres utilisateurs de trading, veuillez d'abord terminer la vérification d'identité",
  300408: 'Non vérifié',
  300409: 'Non Vérifié',
  300410: 'Choisissez la devise.',
  300411: 'Sélectionnez la devise fiduciaire',
  300412: 'Toutes les devises',
  300413: 'Toutes les devises fiat',
  300414: '≈{time} minutes',
  300415: `Le trading P2P n'est pas ouvert aux utilisateurs de portefeuille autorisés pour le moment, veuillez utiliser votre compte SuperEx pour vous connecter et trader en P2P`,
  300416: 'https://support.superex.com/hc/zh-hk/articles/23083845808537',
  300417: 'Acheter',
  300418: 'Numéro de série',
  300419: 'SuperEx Halloween Carnival',
  300420: 'Sign in to enjoy gifts and trade to win bonuses!',
  300421: 'Type',
  300422: 'Récompenses en cryptomonnaie',
  300423: '',
  300424: '',

  400000: 'Première Bourse Crypto Web3',
  400001: 'Rejoignez-nous pour créer un monde financier',
  400002: `Chaque transaction que vous effectuez est un carburant pour que les humains s'envolent dans l'espace`,
  400003: 'Revue passionnante de superex',
  400004: `Engagement actif et sourires partagés : L'histoire de notre mur d'activités`,
  400005: 'Choisir la langue et région',
  400006: '0 RISQUE',
  400007: 'PAS DE KYC',
  400008: 'OUVERT',
  400009: 'FOND',
  400010: 'Explorer Mainnet',
  400011: 'Explorer Testnet',
  400012: 'Documentation du développeur',
  400013: 'Autre',
  400014: 'Zone ET',
  400015: 'Canal de vente',

  400017: 'Saisissez un numéro de portable à 11 chiffres',

  ...frLocal,
  ...frJame,
  ...frGaea,
  ...frAllen
}

export default fr;



// WEBPACK FOOTER //
// ./src/i18n/langs/fr.js